import booleanMaker from 'reducersMakers/booleanMaker';
import * as actions from 'actions';

export default booleanMaker({
  booleanName: 'isFetching',
  trueTypes: [
    actions.GOALS_FETCH
  ],
  falseTypes: [
    actions.GOALS_FETCH_SUCCESS,
    actions.GOALS_FETCH_ERROR
  ]
});




/** WEBPACK FOOTER **
 ** ./src/members/state/goals/goalsFetching/reducer.js
 **/